import { convertADtoBEYear, getThaiMonth } from './localization';

export const getTimeText = (date: moment.Moment) => {
  const day = date.date();
  const month = getThaiMonth(date.month());
  const year = convertADtoBEYear(date.year());
  const time = date.format('hh:mm');
  return `วันที่ ${day} ${month} ${year} เวลา ${time}`;
};
